/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoPropertyConditionType = typeof ListingDetailResponseDtoPropertyConditionType[keyof typeof ListingDetailResponseDtoPropertyConditionType] | null;


export const ListingDetailResponseDtoPropertyConditionType = {
  NEW_BUILD: 'NEW_BUILD',
  FULL_RECONSTRUCTION: 'FULL_RECONSTRUCTION',
  PARTIAL_RECONSTRUCTION: 'PARTIAL_RECONSTRUCTION',
  ORIGINAL: 'ORIGINAL',
  UNDER_CONSTRUCTION: 'UNDER_CONSTRUCTION',
  OTHER: 'OTHER',
} as const;
